export default {
  title: {
    id: 'hub_buying_guide_footer_title',
    defaultMessage: 'See all articles',
  },
  seeAllCategories: {
    id: 'hub_category_tree_see_all_categories',
    defaultMessage: 'See all categories',
  },
  hideCategories: {
    id: 'hub_category_tree_hide_categories',
    defaultMessage: 'Hide categories',
  },
} as const
